import { CategoriesGrid } from '@components/CategoriesGrid/CategoriesGrid'
import { createAppFromCommonTemplate } from '@helpers'
import type { MacroCategoriesCardsProps } from '@velasca/types'

export const renderCategoriesGridApp = (
  categoriesGridEl: HTMLElement | null,
  categoriesGridData: MacroCategoriesCardsProps,
) => {
  createAppFromCommonTemplate(
    categoriesGridEl,
    <CategoriesGrid
      title={null}
      mobileLayout="singleColumn"
      cards={categoriesGridData.imageCards ?? []}
    />,
  )
}
